module.exports = __webpack_public_path__ + "img/jiankangguanli.5c3ca13f.png";